import React__default from 'react';
import { SvgImg } from '../../components/svgImg/svgImg.js';

const RakutenSymbol = ({ width = undefined, height = undefined, fill = '#BF0000' }) => {
    return (React__default.createElement(SvgImg, { viewbox: "0 0 40 40", title: "icons /rakuten R symbol", width: width, height: height, fill: fill },
        React__default.createElement("path", { d: "M11.3499 35.8983L7.20445 32.4189H36.2711L11.3499 35.8983Z", fill: fill }),
        React__default.createElement("path", { d: "M16.0694 29.8116V22.1078H19.4086L25.1886 29.8116H31.1001L24.115 20.5171C26.2929 18.9527 27.7215 16.4155 27.7215 13.5364C27.7215 8.8081 23.8784 4.96936 19.1501 4.96936H11.3499V29.8116H16.0694ZM16.0694 9.68452H19.1501C21.271 9.68452 23.002 11.4111 23.002 13.532C23.002 15.6617 21.2666 17.3839 19.1501 17.3839H16.0694V9.68452Z", fill: fill })));
};

export { RakutenSymbol };
